<template>
  <div id="home">
    <div class="banner">
      <img src="@/assets/images/Banner.svg" />
    </div>
    <div class="text">
      <div class="layout-content">{{ $t('common.aboutUs') }}</div>
    </div>
    <div class="wedo">
      <div class="layout-content">{{ $t('common.aboutUsa') }}</div>
    </div>
    <div class="develope">
      <img class="img" src="@/assets/images/develope.svg" />
    </div>
    <!-- <div class="serve-area">
      <div class="title">服务领域</div>
      <div class="content">
        <div class="item">
          <div class="img">
            <img src="@/assets/images/service-area1.svg" />
          </div>
          <div class="c-title">
            零售业
          </div>
          <div class="c-text">
            我们为零售业品牌门店提供可视化管理解决方案，有效提高全球化、多区域管理效率
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img src="@/assets/images/service-area2.png" />
          </div>
          <div class="c-title">
            金融业
          </div>
          <div class="c-text">
            我们为金融机构提供安全可靠的数据迁移以及数据分析解决方案
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img src="@/assets/images/service-area3.png" />
          </div>
          <div class="c-title">
            制造业
          </div>
          <div class="c-text">
            我们为工厂提供流程管理及质量监管解决方案，有效提高生产效率，降低管理成本
          </div>
        </div>
      </div>
    </div> -->
    <div class="wedo-list">
      <ul class="tab-tilte">
        <!-- <li v-for="(item, index) in title" :key="index" @click="num = index" :class="{ active: num == index }">
          {{ item }}
        </li> -->
        <li @click="num = 0" :class="{ active: num == 0 }">
          <div class="item">
            <img src="@/assets/images/red-circle-internet.svg" />
            <label>{{ $t('common.Sass') }}</label>
          </div>
        </li>
        <li @click="num = 1" :class="{ active: num == 1 }">
          <div class="item">
            <img src="@/assets/images/red-circle-website.svg" />
            <label>{{ $t('common.Industrial') }}</label>
          </div>
        </li>
        <li @click="num = 2" :class="{ active: num == 2 }">
          <div class="item">
            <img src="@/assets/images/red-circle-mobile.svg" />
            <label>{{ $t('common.Mobile') }}</label>
          </div>
        </li>
        <li @click="num = 3" :class="{ active: num == 3 }">
          <div class="item">
            <img src="@/assets/images/red-circle-rocket.svg" />
            <label>{{ $t('common.Analytics and AI') }}</label>
          </div>
        </li>
      </ul>
      <!-- <ul class="tab-content">
        <li v-show="num == 0">
          用户不在需要任何硬件、IT方面的专业技术人员等方面费心思，而专注核心业务的发展；用户在软件方面的费用不需要一次到位，可以按月、或年等周期形式付费，维护、升级等费用也不用额外附加；按需要定购saas平台的相应服务，增加功能或减少自己不需要的模块更加自由；SaaS平台有专业人员对市场以及相应大数据进行研究，加快SaaS平台软件的更新速度；只需要通过浏览器或其他终端设备就可以随时随地应用软件服务。
        </li>
        <li v-show="num == 1">
          工业互联网（Industrial
          Internet）是新一代信息通信技术与工业经济深度融合的新型基础设施、应用模式和工业生态，通过对人、机、物、系统等的全面连接，构建起覆盖全产业链、全价值链的全新制造和服务体系，为工业乃至产业数字化、网络化、智能化发展提供了实现途径，是第四次工业革命的重要基石。
        </li>
        <li v-show="num == 2">
          移动互联网是指移动通信终端与互联网相结合成为一体，是用户使用手机、PAD或其他无线终端设备，通过速率较高的移动网络，在移动状态下(如在地铁、公交车等)随时、随地访问Internet以获取信息，使用商务、娱乐等各种网络服务。
        </li>
        <li v-show="num == 3">
          人工智能 (AI) 让机器可以从经验中学习，适应新的输入并像人一样完成任务。您今天所听说到的大多数 AI
          示例–从下国际象棋的计算机到自动驾驶汽车–都十分依赖深度学习和自然语言处理。使用这些技术，可以训练计算机通过处理大量数据并识别数据中的模式来完成特定任务。
        </li>
      </ul> -->
      <div class="case-example " :class="{ mobile: showMobile }">
        <el-carousel :interval="300000" indicator-position="none" arrow="always">
          <el-carousel-item v-for="item in $t('caseExample')" :key="item.id">
            <div class="box">
              <div class="img">
                <img :src="require('../assets/images/' + item.img)" />
              </div>
              <div class="content">
                <h3 class="title">{{ item.title }}</h3>
                <div class="desc">
                  {{ item.str }}
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="button-box" :class="{ mobile: showMobile }">
        <div class="btn" @click="view('Sass_platforms')">
          {{ $t('common.moreCase') }}
        </div>
      </div>
      <!-- saas_platforms -->
      <!-- <div class="item" @click="view('Sass_platforms')">
        <img src="@/assets/images/red-circle-internet.svg" />
        <label>{{ $t('common.Sass') }}</label>
      </div> -->
      <!-- Industrial_Applications -->
      <!-- <div class="item" @click="view('Industrial_Applications')">
        <img src="@/assets/images/red-circle-website.svg" />
        <label>{{ $t('common.Industrial') }}</label>
      </div> -->
      <!-- Mobile -->
      <!-- <div class="item" @click="view('Mobile')">
        <img src="@/assets/images/red-circle-mobile.svg" />
        <label>{{ $t('common.Mobile') }}</label>
      </div> -->
      <!-- Analytics -->
      <!-- <div class="item" @click="view('Analytics')">
        <img src="@/assets/images/red-circle-rocket.svg" />
        <label>{{ $t('common.Analytics and AI') }}</label>
      </div> -->
    </div>
    <div class="site-map">
      <label>{{ $t('common.clients') }}</label>
      <div class="map-list">
        <div class="item">
          <img src="@/assets/images/intarlinks.png" />
        </div>
        <!-- <div class="item">
          <img src="@/assets/images/bafang.png" />
        </div> -->
        <div class="item">
          <img src="@/assets/images/moodys.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/hsbc.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/ssc.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/johnson and johnson.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/british american tobacco.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/rbs.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/deutsche bank.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/jpmc.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/chinese1.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/chinese2.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/guangfu eletronics.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/deaon.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/vzp.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gjdl.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb1.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb2.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb3.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb4.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb5.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb6.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb7.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb8.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/pb9.png" />
        </div>
      </div>
    </div>
    <div class="contact-us">
      <div>
        © 2019-2021 苏州艾盛信息科技有限公司 版权所有
        <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备20015150号-1</a>
      </div>
      <label class="title" for="Contact Us">{{ $t('common.contact') }}</label>
      <!-- <label class="content">{{ $t("common.aboutUsb") }}</label> -->
      <div class="content">
        <div class="item">
          {{ $t('contact.address') }}
        </div>
        <div class="item">
          {{ $t('contact.email') }}
        </div>
        <div class="item">
          {{ $t('contact.phone') }}
        </div>
      </div>
      <div class="content">
        <el-button type="primary" @click="visible = true" class="ask">
          {{ $t('common.consult') }}
        </el-button>
        <el-button type="primary" @click="visible = true" class="ask">
          {{ $t('common.qq') }}
        </el-button>
      </div>
    </div>

    <el-dialog title="" :visible.sync="visible" width="540px" custom-class="dialog">
      <template v-slot:title>
        <div class="title">
          <div class="English-title">Service&amp;ability</div>
          <div class="modal-name">合作咨询</div>
        </div>
      </template>
      <el-form :model="form" label-position="left" label-width="100px" :rules="rules" size="medium">
        <el-form-item label="客户联系人" prop="name">
          <el-input v-model="form.name" autocomplete="off" class="input"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" autocomplete="off" class="input" type="number"></el-input>
        </el-form-item>
        <el-form-item label="意向类型" prop="region">
          <el-select v-model="form.region" placeholder="请选择活动区域" class="input">
            <el-option label="APP开发" value="APP开发"></el-option>
            <el-option label="小程序开发" value="小程序开发"></el-option>
            <el-option label="行业解决方案" value="行业解决方案"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向描述" prop="desc">
          <el-input type="textarea" :autosize="{ minRows: 3 }" v-model="form.desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="visible = false">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import Bus from "../bus";
  import { Field } from 'vant'

  export default {
    name: 'Home',
    components: {
      [Field.name]: Field,
    },
    data() {
      return {
        value: '',
        mapList: [],
        flag: false,
        visible: false,
        activeName: 'first',
        showMobile: false,
        form: {
          name: '',
          phone: '',
          region: '',
          delivery: false,
          desc: '',
        },
        num: 5,
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入姓名' }],
          phone: [{ required: true, trigger: 'blur', message: '请输入联系电话' }],
          region: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入选择您的意向类型',
            },
          ],
          desc: [{ required: true, trigger: 'blur', message: '请输入您的意向类型' }],
        },
        language: 'zh',
        formLabelWidth: '120px',
      }
    },
    created() {
      // Bus.$off("flag");
      // Bus.$on("flag", (res) => {
      //   console.log(res);
      //   this.flag = res;
      //   console.log(this.flag);
      //   if (this.flag == false) {
      //     this.str = "中文";
      //     this.$i18n.locale = "zh";
      //   } else {
      //     this.str = "English";
      //     this.$i18n.locale = "en";
      //   }
      // });
    },
    mounted() {
      this.showMobile = this.isMobile() ? true : false
      console.log(this.showMobile)
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag
      },
      view(url) {
        this.$router.push({
          path: '/Sass_platforms',
          query: {
            name: url,
          },
        })
      },
    },
  }
</script>
<style scoped lang="scss">
  #home {
    .layout-content {
      display: flex;
      flex: 0 0 90%;
    }
    font-size: 26px;
    .banner {
      width: 100%;
      height: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      background: #f9f9f9;
      padding: 30px;
      color: #4d4d4d;
      text-align: center;
      display: flex;
      justify-content: center;
    }
    .wedo {
      display: flex;
      justify-content: center;
      background: #237687;
      padding: 30px;
      color: #f9f9f9;
      text-align: center;
      .layout-content {
        width: 100%;
        text-align: center;
        justify-content: center;
      }
    }
    .develope {
      display: flex;
      justify-content: center;
      background: #237687;
      padding: 30px;
      .img {
        width: 70%;
      }
    }
    .wedo-list {
      background: #f9f9f9;
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      ul li {
        list-style: none;
      }
      .tab-tilte {
        // height: 50px;
        // line-height: 50px;
        display: flex;
        justify-content: space-between;
        width: 70%;
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: auto;
          text-align: center;
          margin-bottom: 8px;
          img {
            width: 180px;
            height: 180px;
          }
          img:hover {
            cursor: pointer;
          }
          label {
            color: #000;
            height: 60px;
            line-height: 60px;
            font-weight: bold;
          }
          label:hover {
            cursor: pointer;
            color: #20a4bf;
          }
        }
        li {
          width: 20%;
          text-align: center;
          //   background-color: #eee;
          cursor: pointer;
        }
        .active {
          label {
            color: #20a4bf;
          }
        }
      }
      .tab-content {
        width: 70%;
        li {
          color: #4d4d4d;
        }
      }
      .case-example {
        width: 76%;
        // height: 260px;
        margin: 4px 0 0px 0;
        ::v-deep .el-carousel__container {
          padding: 30px;
          .el-carousel__arrow {
            width: 60px;
            height: 60px;
            .el-icon-arrow-right {
              font-size: 28px;
            }
          }
        }
        ::v-deep .el-carousel__item {
          //   height: auto;
          .box {
            display: flex;
            width: 100%;
            overflow: hidden;
            padding-left: 80px;
            margin-top: 60px;
            .img {
              flex: 6;
              overflow: hidden;
              img {
                width: 100%;
                // height: 100%;
              }
              //   width: 300px;
            }
            .content {
              flex: 5;
              padding: 20px;
              //   padding-left: 70px;
              padding-right: 140px;
              .title {
                margin: 15px 0;
                height: 60px;
                font-size: 30px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: #000;
                line-height: 60px;
              }
              .desc {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5;
                overflow: hidden;
                font-size: 24px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: rgba(76, 76, 76, 1);
                line-height: 28px;
              }
            }
          }
          color: #475669;
          font-size: 14px;
          opacity: 0.75;
          //   line-height: 200px;
          margin: 0;
        }

        // .el-carousel__item:nth-child(2n) {
        //   background-color: #99a9bf;
        // }

        // .el-carousel__item:nth-child(2n + 1) {
        //   background-color: #d3dce6;
        // }
        &.mobile {
          ::v-deep .el-carousel__container {
            height: 480px;
          }
          .box {
            padding-left: 0;
            flex-direction: column;
            .content {
              padding-right: 0;
            }
          }
        }
      }
      .button-box {
        text-align: center;
        background: #20a4bf;
        border-radius: 10px;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        padding: 10px 18px;
        margin-top: 30px;
        color: rgba(255, 255, 255, 1);
        &:hover {
          cursor: pointer;
          opacity: 0.8;
          box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
        }
        &.mobile {
          margin-top: 2px;
        }
      }
    }
    /* 动态绑定class 点击标题改变样式 */
    .tab-tilte .active {
      // background-color: #ff1100;
      color: #237687;
    }
  }
  .serve-area {
    background: #ced0d8;
    padding: 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 32px;
      color: #000;
      line-height: 60px;
      margin-bottom: 20px;
      width: 90%;
    }
    .content {
      display: flex;
      justify-content: space-between;
      padding: 0 10%;
      padding-bottom: 60px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        margin-bottom: 8px;
        padding: 0 2px;
        .img {
          width: 180px;
          height: 180px;
          img {
            width: 100%;
          }
        }
        .c-title {
          color: #3a4258;
          font-weight: bold;
          font-size: 24px;
          letter-spacing: 6px;
          margin-top: 20px;
          width: 100%;
          &::after {
            content: '';
            display: block;
            width: 80%;
            margin: 0 10%;
            height: 3px;
            background: #3a4258;
            margin-bottom: 10px;
          }
        }
        .c-text {
          color: #1c7296;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          line-height: 28px;
          margin: 0 10%;
          letter-spacing: 1px;
        }
      }
    }
  }
  .contact-us {
    background: #7d7d7d;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #f9f9f9;
    text-align: center;
    padding: 30px;
    .title {
      font-size: 32px;
    }
    .content {
      width: 90%;
      font-size: 26px;
      margin-top: 15px;
      margin-bottom: 45px;
      .item {
        line-height: 40px;
      }
    }
    .ask {
      // width: 180px;
      height: 70px;
      font-size: 26px;
      padding: 0 32px;
      background: #3ebbd5;
      border: none;
      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
      margin-left: 40px;
    }
    .send-input {
      border-radius: 4px;
      width: 607px;
      font-size: 26px;
    }
    .send-icon-box {
      display: flex;
    }
    .send-icon {
      width: 60px;
      height: 60px;
    }
  }
  .site-map {
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    label {
      width: 90%;
      color: #237687;
      font-size: 32px;
    }
    .map-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      .item {
        flex: 0 0 calc(12% - 30px);
        margin: 25px 15px;
        text-align: center;
        img {
          width: 160px;
          height: 160px;
        }
      }
    }
  }
  ::v-deep .el-tabs {
    .el-tabs__item {
      font-size: 26px;
      height: auto;
    }
  }
  ::v-deep .el-dialog {
    padding: 20px 60px;
  }
  ::v-deep .el-form {
    .el-form-item__label {
      font-size: 20px;
      line-height: 48px;
      height: 48px;
    }
    .el-form-item__content {
      line-height: 48px;
      .el-input__inner {
        line-height: 48px;
        height: 48px;
      }
    }
  }
  .dialog {
    font-size: 20px;
    .title {
      text-align: center;
      padding-top: 14px;
      .English-title {
        margin-bottom: 10px;
        font-size: 32px;
        font-family: HiraKakuStd-W8;
        font-weight: normal;
        color: rgba(20, 20, 20, 1);
        letter-spacing: 1px;
      }
      .modal-name {
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(20, 20, 20, 1);
        letter-spacing: 1px;
      }
    }
    .input {
      width: 100%;
    }
  }
</style>
